import React from "react";

export const PurchasesIcon = ({nameOfClass}) => {
    return (
        <svg
            className={nameOfClass}
            width="23"
            height="25"
            viewBox="0 0 23 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.3492 19.3809H2.04553C1.72836 19.3809 1.42417 19.2549 1.19989 19.0306C0.975608 18.8063 0.849609 18.5022 0.849609 18.185V2.04556C0.849609 1.72838 0.975608 1.42418 1.19989 1.1999C1.42417 0.975611 1.72836 0.849609 2.04553 0.849609H14.3636C14.6807 0.849609 14.9849 0.975611 15.2092 1.1999C15.4335 1.42418 15.5595 1.72838 15.5595 2.04556V12.0031"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.117 21.2058C17.6582 21.2058 19.7183 19.1457 19.7183 16.6044C19.7183 14.0631 17.6582 12.0029 15.117 12.0029C12.5757 12.0029 10.5156 14.0631 10.5156 16.6044C10.5156 19.1457 12.5757 21.2058 15.117 21.2058Z"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.4316 19.7959L21.8496 23.2139"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.3418 4.79297H13.0623"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.3418 8.64453H13.0623"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.3418 12.4941H8.42089"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
